<div class="wrapper">
    <div class="addBuilding">
        <app-type-ahead-buildings
            [searchParameters]="typeAheadSearchByEntityParameters"
            [isActive]="true"
            (selectedBuildingChange)="onSelectedBuilding($event)"
        ></app-type-ahead-buildings>
    </div>

    @if (buildingsDatasource) {
        <div class="grid">
            <app-server-side-grid
                [colDefs]="gridColumns"
                [datasource]="buildingsDatasource"
                [noRows]="noResults()"
                [titleNoData]="'No Buildings available.'"
                [getRowId]="getRowIdFn"
            ></app-server-side-grid>
        </div>
    }
</div>
